<div class="one-personal row" (click)="openDialog()">
    <div class="personal-avatar col-md-3">
        <one-avatar [imageUrl]="userAvartarUrl" [size]="42"></one-avatar>
    </div>
    <div class="personal-info col-md-9">
        <div class="fullname basic-info">
            {{userFullname}}
            <span class="title basic-info">
                {{userTitle}}
            </span>
        </div>
    </div>
</div>
